import {
    Box,
    Container,
    Grid,
    Skeleton,
    Stack,
    styled,
    SwipeableDrawer,
    TextField,
    Typography,
    IconButton,
    Button,
    CircularProgress,
    Divider,
    Snackbar,
    TableContainer,
    Table,
    TableHead,
    Paper,
    TableRow,
    TableCell,
    TableBody,
    TablePagination,
} from "@mui/material";
import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
    where,
} from "firebase/firestore";
import React, { useState } from "react";
import { UserAuth } from "../../context/AuthContext";
import { db } from "../../firebase.config";
import CustomButton from "../../Components/CustomButton";
import EventCard from "../../Components/EventCard";
import Iconify from "../../Components/Iconify";
import { sendPasswordResetEmail } from "firebase/auth";
import { Facebook, Google } from "@mui/icons-material";
import { Variables } from "../../context/VariableContext";
import CustomTextField from "../../Components/CustomTextField";
import Scrollbar from "../../Components/scrollBar";

const Coordonnées = ({ }) => {
    const { openLogin, setOpenLogin } = Variables();
    const [loading, setLoading] = React.useState(false);
    const [events, setEvents] = React.useState([]);
    const [paiements, setPaiement] = React.useState([]);
    const [countTmp, setCount] = React.useState(0);
    const createEventList = (doc) => {
        setEvents((events) => [...events, doc]); // ajouter a la fin
    };
    React.useEffect(() => {
        (async () => {
            try {
                //
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        })();
    }, []);

    const handleCopy = (link) => {
        navigator.clipboard.writeText(link)
        setMsg({ content: 'Lien copié dans le papier presse', color: 'green' });
        setOpenSnack(true);
    };

    //  snack bar
    const [openSnack, setOpenSnack] = React.useState(false);
    const [msg, setMsg] = React.useState({ content: '', color: '' });
    const handleCloseSnack = () => {
        setOpenSnack(false);
    };


    return (
        <Box>
            <Stack></Stack>
            <Snackbar
                open={openSnack}
                autoHideDuration={5000}
                onClose={handleCloseSnack}
                message={
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography paddingRight={1} variant='body2'>{msg.content}{' '}</Typography>
                        <Iconify
                            sx={{ color: msg.color }}
                            icon={`${msg.red ? 'system-uicons:cross-circle' : 'mdi:success-circle-outline'}`}
                        />
                    </Box>
                }
            />
        </Box>
    );
};

export default Coordonnées;
